import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './login.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Login(props) {
    const apiUrl = process.env.REACT_APP_BASEURL;
    const [username,setUsername] = useState();
    const [password,setPassword] = useState(); 
    const [alert, setAlert] = useState(false);
    const [message, setMessage] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
      if (alert) {
          setTimeout(() => { setAlert(false); }, 5000);
      }
  },
  [alert]);

  

  async function loginUser(credentials) {
    // console.log("here are your credenials login 25",credentials);
    axios.post(apiUrl + "/api/Users/AuthenticateUser", credentials, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        // console.log("here is your token at login.js loginUser: ", response.data);
        props.setToken(response.data);
        navigate('/');
        // console.log("Token after setting: ", props.token); // Log the token after setting it
        // console.log(response.data);
      }
      )
      .catch((error) => {
        console.log(error);
      });
   }
  

    const handleSubmit = async e => {
        e.preventDefault();
        const thisToken = await loginUser({
          username,
          password
        });
     
      }
    
      return (
        <div className="login wrapper fadeInDown">
            <div className="login formContent ">
                <h1 className="login centered">Please Log In</h1>
                <div className="login centered">
                    {alert && <h2 style={{ color: 'red' }}>{message}</h2>}
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="centered">
                        <input type="text" value={username || ""} onChange={e => setUsername(e.target.value)} id="loginName" className="login fadeIn second" placeholder="Email" />
                    </div>
                    <div className="centered">
                        <input type="password" value={password || ""} onChange={e => setPassword(e.target.value)} id="loginPwd" className="login fadeIn third" placeholder="Password" />
                    </div>
                    <div className="centered">
                        <input type="submit" className="login fadeIn fourth" value="Log In" />
                    </div>
                </form>
            </div>  
        </div>
    )
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
};